export default __webpack_public_path__ + "static/media/Rectangle 46.9a8e1d25.jpg";